import { useState } from "react";
import { Checkbox } from "antd";
import StyledModal from "../../../components/CustomModal";
import { StyledButton } from "../../../components/styles";

interface ChangeStatusModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (sendEmail: boolean) => void;
    loading: boolean;
    currentStatusLabel: string;
    newStatusLabel: string;
}

const ChangeStatusModal = ({ isOpen, onClose, onConfirm, loading, currentStatusLabel, newStatusLabel }: ChangeStatusModalProps) => {
    const [sendEmail, setSendEmail] = useState(true);

    const handleConfirm = () => {
        onConfirm(sendEmail);
    };

    const handleClose = () => {
        setSendEmail(true); // Reset to default
        onClose();
    };

    return (
        <StyledModal
            draggable={true}
            footer={
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", width: "100%" }}>
                    <StyledButton onClick={handleClose} disabled={loading}>Cancel</StyledButton>
                    <StyledButton type="primary" onClick={handleConfirm} loading={loading} disabled={loading}>
                        Confirm
                    </StyledButton>
                </div>
            }
            open={isOpen}
            onCancel={handleClose}
            title="Confirm Status Change"
        >
            <div style={{ marginTop: "20px" }}>
                <p>
                    Are you sure you want to change the status from <strong>{currentStatusLabel}</strong> to <strong>{newStatusLabel}</strong>?
                </p>
                <div style={{ marginTop: "16px" }}>
                    <Checkbox
                        checked={sendEmail}
                        onChange={(e) => setSendEmail(e.target.checked)}
                    >
                        Send email notification
                    </Checkbox>
                </div>
            </div>
        </StyledModal>
    );
};

export default ChangeStatusModal;
